export interface DeviceManagementState {
  devices: Object;
  coroner: Object;
}

export const initialDeviceManagementState: DeviceManagementState = {
  devices: {},
  coroner: {}
};
